// removed by extract-text-webpack-plugin
module.exports = {"map":"dh-french-moland-kart-map"};


//////////////////
// WEBPACK FOOTER
// ./src/v1/components/Map.css
// module id = 46
// module chunks = 0